export default function ProgressBar({ value, label }) {
  return <div className="progress-block"><div className="progress-label"><span>{label}</span><strong>{Math.round(value || 0)}%</strong></div><div className="progress-track"><span style={{ width: Math.max(3, Math.min(100, value || 0)) + '%' }} /></div></div>;
}
